// extracted by mini-css-extract-plugin
export default {"button":"button-secondary_button__rvAvn","icon":"button-secondary_icon__3AaNU"};